import { useLayoutEffect } from "react";

// Sets the page title and meta description before GA logs the page view.
export function usePageMeta(title, description) {
  useLayoutEffect(() => {
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  }, [title, description]);
}
